import CircularProgress from '@mui/material/CircularProgress'
import { CONSTS } from 'config/objectConst'
import { appSelectors } from 'redux/reducers/app'
import { useAppSelector } from 'shared/hooks'
import { Button } from 'shared/ui'

import { api } from '../../api'
import { useCurrentId } from '../../hooks'
import css from './ChatHeader.module.scss'

function SyncButton() {
	const [send, { isLoading }] = api.useSyncMutation()

	const id = useCurrentId()

	return (
		<Button
			className={css.sync}
			onClick={() => !isLoading && send(id)}
			type='button'
			variant='secondary'
		>
			{isLoading ? (
				<CircularProgress
					classes={{ colorPrimary: 'material-loader-black' }}
					size={20}
				/>
			) : (
				'Sync'
			)}
		</Button>
	)
}

function useSyncAllowed() {
	const id = useAppSelector(
		state => appSelectors.persona(state)?.personaId ?? ''
	)

	return (
		CONSTS.BETA_FEATURES.SYNC_INTEGRATION_PERSONAS.includes('any') ||
		CONSTS.BETA_FEATURES.SYNC_INTEGRATION_PERSONAS.includes(id)
	)
}

export { SyncButton, useSyncAllowed }
